import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { getBuildkiteFrontendVersion } from "~/lib/frontendVersion";

export interface DatadogRumInitConfiguration {
  applicationId: string;
  clientToken: string;
  env: string;
}

export default function initDatadogRum(config: DatadogRumInitConfiguration) {
  datadogRum.init({
    ...config,

    site: "datadoghq.com",
    service: "pipelines-build-app",

    version: getBuildkiteFrontendVersion(),
    sessionSampleRate: 100,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: true })],

    // Disable session replay by default
    sessionReplaySampleRate: 0,
    enableExperimentalFeatures: ["feature_flags"],
  });

  // Initialize feature flags
  Object.keys(Features).forEach((feature) => {
    datadogRum.addFeatureFlagEvaluation(feature, Features[feature]);
  });
}
